import * as rest from './RestUtil';
import { getFunctionBaseUrl } from './RestUrls';

export const sendInvoices = async (reports: string, format: string) => {
  const url = `${getFunctionBaseUrl()}/api/sendInvoices/${reports}/${format}/`;
  const response = await rest.get(url);
  return response;
}

export const generateInvoices = async (reports: string, format: string) => {
  const url = `${getFunctionBaseUrl()}/api/generateInvoices/${reports}/${format}/`;
  const response = await rest.get(url);
  return response;
}

export const loadInvoices = async (reports: string, format: string) => {
  const url = `${getFunctionBaseUrl()}/api/loadInvoices/${reports}/${format}/`;
  const response = await rest.download(url);
  return response;
}

export const loadInvoice = async (id: string) => {
  const url = `${getFunctionBaseUrl()}/api/loadInvoice/${id}/`;
  const response = await rest.download(url);
  return response;
}

export const getInvoiceMaterial = async (ids: number[], period = "null") => {
  const url = `${getFunctionBaseUrl()}/api/invoiceMaterialGet/${period}/${ids}`;
  const response = await rest.get(url);  
  return response;
}